module.exports = " <label class=vc-checkbox :class=\"{'label-left': labelLeft}\"> <input type=checkbox :name=name :value=value v-model=model> <div class=vc-checkbox-label v-if=\"label && labelLeft\">{{label}}</div> <div class=vc-checkbox-icon></div> <div class=vc-checkbox-label v-if=\"label && !labelLeft\">{{label}}</div> </label> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/checkbox.vue
 ** module id = 436
 ** module chunks = 1
 **/